export const MAIN_ADDRESS_ID = "01";

export const companyAddressDefaultValues = (
    defaultValues: MyBrokerApi.Address = {} as MyBrokerApi.Address,
): MyBrokerApi.Address => {
    const { street, houseNumber, boxNumber, zipCode, city, country, type } = defaultValues;
    return {
        street: street || "",
        houseNumber: houseNumber || "",
        boxNumber: boxNumber || "",
        zipCode: zipCode || "",
        city: city || "",
        country: { id: country?.id || "" },
        type: { id: type?.id || MAIN_ADDRESS_ID },
    };
};

export const companyAddressFixture = (): MyBrokerApi.Address => ({
    street: "Street name",
    houseNumber: "1",
    boxNumber: "Box 123",
    zipCode: "1234-123",
    city: "City name",
    country: { id: "B" },
    type: { id: "01" },
});
